// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"368":"afdc2476","612":"6a127b41","818":"3e377a8c","900":"a64e1415"}[chunkId] + ".js";
};